import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { SiLibreofficewriter } from 'react-icons/si';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useToast } from "../../../hooks/useToast";
import { InfluencerImg } from '../../../static/constant/imgConstants';
import { getUserInfo, getUserInfoReset } from '../../../store/authStore/actions/authActions/getUserInfoActions';
import {
    sendOtpForMobileVerified,
    sendOtpForMobileVerifiedReset
} from "../../../store/authStore/actions/authActions/sendOtpForMobileVerifiedAction";
import {
    verifyMobileOtp,
    verifyMobileOtpReset
} from "../../../store/authStore/actions/authActions/verifyMobileOtpActions";
import {
    updateUserInfo,
    updateUserInfoReset
} from "../../../store/authStore/actions/authActions/updateUserInfoActions";
import { myChannelList } from '../../../store/BusinessStore/actions/InfluencerChannelActions/myChannelListActions';
import {
    getCampaignDetailsForDashboard
} from '../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/getCampaignDetailsForDashboardActions';
import {
    getPotentialIncomeMissedByMonthAndYearForDashboard
} from '../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/getPotentialIncomeMissedByMonthAndYearForDashboardActions';
import {
    getTotalIncomeByMonthAndYearForDashboard
} from '../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/getTotalIncomeByMonthAndYearForDashboardActions';
import VerifyPopup from '../VerifyPopup/VerifyPopup';
import { getAllCountry } from "../../../store/publicStore/actions/publicActions/getAllCountryActions";
import DropdownWithSearch from "../../common/DropdownWithSearch/DropdownWithSearch";
import Footer from '../../common/Footer/Footer';
import Popup from '../../popups/Popup/Popup';
import "./InfluencerDashboard.css";

const InfluencerDashboard = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const Toast = useToast();

    const getUserInfoReducerData = useSelector(state => state.getUserInfoReducer.data);
    const getCampaignDetailsForDashboardReducer = useSelector(state => state.getCampaignDetailsForDashboardReducer);
    const getPotentialIncomeMissedByMonthAndYearForDashboardReducer = useSelector(state => state.getPotentialIncomeMissedByMonthAndYearForDashboardReducer);
    const getTotalIncomeByMonthAndYearForDashboardReducer = useSelector(state => state.getTotalIncomeByMonthAndYearForDashboardReducer);
    const getAllCountryReducer = useSelector(state => state.getAllCountryReducer);
    const sendOtpForMobileVerifiedReducer = useSelector(state => state.sendOtpForMobileVerifiedReducer);
    const utilReducers = useSelector(state => state.utilReducers)
    const getUserInfoReducer = useSelector(state => state.getUserInfoReducer);
    const verifyMobileOtpReducer = useSelector(state => state.verifyMobileOtpReducer)
    const updateUserInfoReducer = useSelector(state => state.updateUserInfoReducer)


    const [totalIncomeDate, setTotalIncomeDate] = useState(moment((new Date())).format("YYYY-MM"));
    const [potentialMissedIncomeDate, setPotentialMissedIncomeDate] = useState(moment((new Date())).format("YYYY-MM"));

    const [isPopupOpen, setPopupOpen] = useState(false);
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [isPhoneVerifyPopupOpen, setIsPhoneVerifyPopupOpen] = useState(false);
    const [isPopupForTokenExpireOpen, setPopupForTokenExpireOpen] = useState(false);
    const [isPopupForInstagramTokenExpireOpen, setPopupForInstagramTokenExpireOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const [countryCode, setCountryCode] = useState(null); // State for country code and phone number
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [gender, setGender] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otpMobile, setOtpMobile] = useState(new Array(4).fill(''));
    const [message, setMessage] = useState('');
    const [otpShow, setOtpShow] = useState(false);
    const [referredBy, setReferredBy] = useState('');

    const userInfo = getUserInfoReducer?.data;
    const isAppleUser = userInfo?.firstName?.toLowerCase() === 'apple' && userInfo?.lastName?.toLowerCase() === 'user';


    // Platform filter state for dashboard APIs
    const [platformFilter, setPlatformFilter] = useState('ALL');

    useEffect(() => {
        dispatch(getUserInfo((status, response, message) => {
            if (status === 200) {
                if (response?.isTokenExpire) {
                    setPopupForTokenExpireOpen(true);
                }
                if (response?.isInstagramTokenExpire) {
                    setPopupForInstagramTokenExpireOpen(true);
                }
            }
        }));
        dispatch(myChannelList((status, response, message) => {
            if (!(userInfo?.firstName && userInfo?.lastName && userInfo?.country?.countryId && userInfo?.phoneNumber) || isAppleUser) {
                setIsPhoneVerifyPopupOpen(true)
            } else if (status === 302) {
                setPopupOpen(true)
            }
            // else if (userInfo?.isTokenExpire) {
            //     console.log("userInfo?.isTokenExpire", userInfo?.isTokenExpire)
            //     setPopupForTokenExpireOpen(true)
            // }

        }))
    }, [isPhoneVerifyPopupOpen]);

    useEffect(() => {

        dispatch(getAllCountry());
        dispatch(getPotentialIncomeMissedByMonthAndYearForDashboard({
            "month": moment(potentialMissedIncomeDate).format("MM"),
            "year": moment(potentialMissedIncomeDate).format("YYYY"),
            ...(platformFilter !== 'ALL' && { platform: platformFilter })
        }))
        dispatch(getTotalIncomeByMonthAndYearForDashboard({
            "month": moment(totalIncomeDate).format("MM"),
            "year": moment(totalIncomeDate).format("YYYY"),
            ...(platformFilter !== 'ALL' && { platform: platformFilter })
        }))
    }, [])

    useEffect(() => {
        dispatch(getPotentialIncomeMissedByMonthAndYearForDashboard({
            "month": moment(potentialMissedIncomeDate).format("MM"),
            "year": moment(potentialMissedIncomeDate).format("YYYY"),
            ...(platformFilter !== 'ALL' && { platform: platformFilter })
        }))
    }, [potentialMissedIncomeDate, platformFilter])

    useEffect(() => {
        dispatch(getTotalIncomeByMonthAndYearForDashboard({
            "month": moment(totalIncomeDate).format("MM"),
            "year": moment(totalIncomeDate).format("YYYY"),
            ...(platformFilter !== 'ALL' && { platform: platformFilter })
        }))
    }, [totalIncomeDate, platformFilter])

    // Single source of truth for campaign details call
    useEffect(() => {
        dispatch(getCampaignDetailsForDashboard({ platform: platformFilter === 'ALL' ? "" : platformFilter }))
    }, [platformFilter])

    function formatNumber(value) {
        if (value >= 1_000_000) {
            return (value / 1_000_000).toFixed(1) + "M"; // Formats as millions
        } else if (value >= 1_000) {
            return (value / 1_000).toFixed(1) + "K"; // Formats as thousands
        }
        return value; // If less than 1,000, return the number as is
    }

    const validateForm = (data) => {
        let formErrors = {};

        if (!data.firstName.trim()) {
            formErrors.firstName = 'First name is required';
        } else if (!/^[a-zA-Z\s]+$/.test(data.firstName)) {
            formErrors.firstName = 'First name should only contain alphabets';
        }
        if (!data.lastName.trim()) {
            formErrors.lastName = 'Last name is required';
        } else if (!/^[a-zA-Z\s]+$/.test(data.lastName)) {
            formErrors.lastName = 'Last name should only contain alphabets';
        }
        // gender is optional
        if (!data.countryId) {
            formErrors.countryId = 'Country is required';
        }

        // Validate Phone Number
        if (!data.phoneNumber.trim()) {
            formErrors.phoneNumber = 'Phone number is required';
        } else if (!/^\d{10}$/.test(data.phoneNumber)) {
            formErrors.phoneNumber = 'Enter a valid 10-digit phone number';
        }

        return formErrors;
    };

    const handleVerify = () => {
        if (otpMobile.join('').length !== 4) {
            setMessage('* Please enter valid OTP');
        } else {
            setMessage('');
            dispatch(verifyMobileOtp({
                sessionCode: utilReducers.sessionToken,
                phoneOtp: otpMobile.join(''),
                emailOtp: null,
                userType: "INFLUENCER"
            }));
            // dispatch(verifyOtpForLogin({
            //     sessionCode: utilReducers.sessionToken,
            //     phoneOtp: otpMobile.join(''),
            //     emailOtp: otpEmail.join('')
            // }));
        }
    };

    const handleChange2 = (e, index) => {
        const { value } = e.target;
        if (/^[0-9]?$/.test(value)) { // Only allow numeric input
            const newOtp = [...otpMobile];
            newOtp[index] = value;
            setOtpMobile(newOtp);

            // Move to the next input if current one is filled
            if (value && index < 3) {
                document.getElementById(`mobile-input-${index + 1}`).focus();
            }
        }
    };

    const handleKeyDown2 = (e, index) => {
        // Move to the previous input if Backspace is pressed and input is empty
        if (e.key === 'Backspace' && !otpMobile[index] && index > 0) {
            document.getElementById(`mobile-input-${index - 1}`).focus();
        }
    };

    const handlePaste2 = (e) => {
        const paste = e.clipboardData.getData('text').slice(0, 4).split('');
        if (/^\d+$/.test(paste.join(''))) {
            setOtpMobile(paste);
            paste.forEach((value, index) => {
                if (index < 4) {
                    document.getElementById(`mobile-input-${index}`).value = value;
                }
            });
        }
    };

    const handleSendOtp = () => {
        const formData = {
            firstName: firstName,
            lastName: lastName,
            gender: gender,
            phoneNumber: phoneNumber,
            countryId: countryCode?.countryId
        };

        const formErrors = validateForm(formData);
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setErrors({});
            dispatch(sendOtpForMobileVerified({
                "firstName": formData.firstName.trim(),
                "lastName": formData.lastName.trim(),
                "gender": formData.gender,
                "email": userInfo.email,
                "countryId": countryCode?.countryId || 1,
                "phoneNumber": formData.phoneNumber,
                "userType": (userInfo.userType === "AGENCY" || userInfo.userType === "BRAND") ? userInfo.userType : "INFLUENCER",
                "referredBy": referredBy.trim() || null
            }));
        }
    }

    const handleUpdateProfileOnly = () => {
        const formData = {
            firstName: firstName,
            lastName: lastName,
            gender: gender,
            phoneNumber: phoneNumber,
            countryId: countryCode?.countryId
        };

        const formErrors = validateForm(formData);
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setErrors({});
            dispatch(updateUserInfo({
                "userId": userInfo.userId,
                "firstName": formData.firstName.trim(),
                "lastName": formData.lastName.trim(),
                "gender": formData.gender,
                "email": userInfo.email,
                "countryId": countryCode?.countryId || 1,
                "phoneNumber": formData.phoneNumber,
                "referredBy": referredBy.trim() || null
            }));
        }
    }

    useEffect(() => {
        if (getUserInfoReducer.status === 200) {
            if (!userInfo?.phoneNumber) {
                setIsPhoneVerifyPopupOpen(true)
            } else if (isPhoneVerifyPopupOpen) {
                const hasFirstName = userInfo?.firstName && userInfo?.firstName !== 'Apple';
                const hasLastName = userInfo?.lastName && userInfo?.lastName !== 'User';

                if (hasFirstName && hasLastName && userInfo?.country?.countryId) {
                    setIsPhoneVerifyPopupOpen(false);
                }
            }
        } else if (getUserInfoReducer.status === 403) {
            Toast(getUserInfoReducer.message, 'error');
            dispatch(getUserInfoReset());
        } else if (getUserInfoReducer.status) {
            Toast(getUserInfoReducer.message, 'info');
            dispatch(getUserInfoReset());
        }
    }, [getUserInfoReducer]);

    useEffect(() => {
        if (userInfo) {
            setFirstName(isAppleUser ? '' : userInfo.firstName || '');
            setLastName(isAppleUser ? '' : userInfo.lastName || '');
            setPhoneNumber(userInfo.phoneNumber || '');
            setGender(userInfo.gender || '');
            setReferredBy(userInfo.referredBy || '');
            if (userInfo.country && getAllCountryReducer?.data) {
                const country = getAllCountryReducer.data.find(c => c.countryId === userInfo.country.countryId);
                if (country) setCountryCode(country);
            }
        }
    }, [userInfo, getAllCountryReducer?.data]);

    useEffect(() => {
        if (sendOtpForMobileVerifiedReducer.status === 200) {
            Toast(sendOtpForMobileVerifiedReducer.message, 'success');
            setOtpShow(true);
            dispatch(sendOtpForMobileVerifiedReset());
            // navigate('/verifyOtp');
        } else if (sendOtpForMobileVerifiedReducer.status === 403) {
            Toast(sendOtpForMobileVerifiedReducer.message, 'error');
            dispatch(sendOtpForMobileVerifiedReset());
        } else if (sendOtpForMobileVerifiedReducer.status === 302) {
            Toast(sendOtpForMobileVerifiedReducer.message, 'error');
            dispatch(sendOtpForMobileVerifiedReset());
        } else if (sendOtpForMobileVerifiedReducer.status) {
            Toast(sendOtpForMobileVerifiedReducer.message, 'info');
            dispatch(sendOtpForMobileVerifiedReset());
        }

        // Log the reducer state for debugging

    }, [sendOtpForMobileVerifiedReducer]);

    useEffect(() => {
        if (verifyMobileOtpReducer.status === 200) {
            Toast(verifyMobileOtpReducer.message, 'success')
            setSuccessMessage(verifyMobileOtpReducer.message);
            setIsSuccessPopupOpen(true);
            dispatch(getUserInfo());
            setOtpShow(false);
            dispatch(verifyMobileOtpReset())
        } else if (verifyMobileOtpReducer.status === 302) {
            Toast(verifyMobileOtpReducer.message, 'error')
            dispatch(verifyMobileOtpReset())
        } else if (verifyMobileOtpReducer.status === 303) {
            Toast(verifyMobileOtpReducer.message, 'error')
            dispatch(verifyMobileOtpReset())
        } else if (verifyMobileOtpReducer.status === 305) {
            setMessage(verifyMobileOtpReducer?.message)
            dispatch(verifyMobileOtpReset())
        } else if (verifyMobileOtpReducer.status === 403) {
            Toast(verifyMobileOtpReducer.message, 'error')
            dispatch(verifyMobileOtpReset())
        } else if (verifyMobileOtpReducer.status) {
            Toast(verifyMobileOtpReducer.message, 'info')
            dispatch(verifyMobileOtpReset())
        }
    }, [verifyMobileOtpReducer]);

    useEffect(() => {
        if (updateUserInfoReducer.status === 200) {
            Toast(updateUserInfoReducer.message, 'success')
            setSuccessMessage(updateUserInfoReducer.message);
            setIsSuccessPopupOpen(true);
            dispatch(getUserInfo());
            dispatch(updateUserInfoReset());
        } else if (updateUserInfoReducer.status === 403) {
            Toast(updateUserInfoReducer.message, 'error')
            dispatch(updateUserInfoReset())
        } else if (updateUserInfoReducer.status) {
            Toast(updateUserInfoReducer.message, 'info')
            dispatch(updateUserInfoReset())
        }
    }, [updateUserInfoReducer]);



    return (
        <div className="w-full h-full bg-[#EDEEF1] overflow-scroll">
            <div className="w-full flex flex-col">
                <div className="px-[4rem] mt-[3rem]">
                    <h2 className="text-[2.8rem] text-black  inter-font font-[500]">
                        Hii {getUserInfoReducerData?.firstName ? getUserInfoReducerData?.firstName : "INFLUENCER"} !
                    </h2>
                    <h2 className="text-[1.8rem] text-black font-[500] mt-2">
                        Welcome to creator dashboard lets collaborate!
                    </h2>
                    <div className="flex justify-between items-center py-[3rem]">
                        <h2 className="text-[2.8rem] text-black inter-font font-[500]">
                            Dashboard
                        </h2>
                        <select
                            className="border-2 border-gray-300 w-[20rem] p-3 pr-14 rounded-md text-[1.4rem] inter-font font-[400] outline-none bg-white"
                            value={platformFilter}
                            onChange={(e) => setPlatformFilter(e.target.value)}
                        >
                            <option value="ALL">All</option>
                            <option value="YOUTUBE">YouTube</option>
                            <option value="INSTAGRAM">Instagram</option>
                        </select>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[4rem] px-[4rem] ">
                    <div
                        className="bg-white shadow-md rounded-[1.2rem] flex flex-col justify-center items-center p-[2rem]">
                        <div className='w-full flex justify-between items-center'>
                            <h3 className="text-[#000000] text-[2rem] inter-font font-[500]">Campaign Participated</h3>
                            <div className='w-[7.1rem] h-[7.1rem]'>
                                <img src={InfluencerImg.info1} alt="Campaign Participated"
                                    className="w-full h-full mb-2" />
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#38414A] text-[5.5rem] inter-font font-[700] mt-1 text-start">{getCampaignDetailsForDashboardReducer?.data?.campaignParticipated}</p>
                        </div>
                    </div>

                    <div
                        className="bg-white shadow-md rounded-[1.2rem] flex flex-col justify-center items-center p-[2rem]">
                        <div className='w-full flex justify-between items-center'>
                            <h3 className="text-[#000000] text-[2rem] inter-font font-[500]">Campaign Missed</h3>
                            <div className='w-[7.1rem] h-[7.1rem]'>
                                <img src={InfluencerImg.info2} alt="Campaign Participated"
                                    className="w-full h-full mb-2" />
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#38414A] text-[5.5rem] inter-font font-[700] mt-1 text-start">{getCampaignDetailsForDashboardReducer?.data?.campaignMissed}</p>
                        </div>
                    </div>

                    <div
                        className="bg-white shadow-md rounded-[1.2rem] flex flex-col justify-center items-center p-[2rem]">
                        <div className='w-full flex justify-between items-center'>
                            <h3 className="text-[#000000] text-[2rem] inter-font font-[500]">Available Campaign</h3>
                            <div className='w-[7.1rem] h-[7.1rem]'>
                                <img src={InfluencerImg.info3} alt="Campaign Participated"
                                    className="w-full h-full mb-2" />
                            </div>
                        </div>
                        <div className="w-full">
                            <p className="text-[#38414A] text-[5.5rem] inter-font font-[700] mt-1 text-start">{getCampaignDetailsForDashboardReducer?.data?.availableCampaign}</p>
                        </div>
                    </div>
                    <div
                        className="bg-white shadow-md rounded-[1.2rem] flex flex-col justify-center items-center p-[2rem]">
                        <div className='w-full flex justify-between mb-[5rem] items-center'>
                            <h3 className="text-[#000000] text-[2rem] text-start inter-font font-[500]">Total Income by
                                Month<br />
                                and Year</h3>
                            <div className='w-[7.1rem] h-[7.1rem]'>
                                <img src={InfluencerImg.info4} alt="Campaign Participated"
                                    className="w-full h-full mb-2" />
                            </div>
                        </div>
                        <div className="influencers-date-picker w-full flex justify-between items-center">
                            <p className="text-[#38414A] text-[5.4rem] inter-font font-[700]">{
                                formatNumber(getTotalIncomeByMonthAndYearForDashboardReducer?.data?.potentialIncome || 0)}</p>
                            <div className="influencers-date-picker w-[10rem] flex justify-between items-center">
                                <DatePicker
                                    selected={totalIncomeDate}
                                    onChange={(date) => setTotalIncomeDate(date)}
                                    dateFormat="MM/yyyy"
                                    maxDate={moment((new Date())).format("YYYY-MM")}
                                    showMonthYearPicker
                                    className='mt-2 border border-[#D5D5D5] text-[#2B303466] w-[15rem] text-[1.6rem] inter-font font-[500] p-2 rounded-[0.6rem] text-center'
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        className="bg-white shadow-md rounded-[1.2rem] flex flex-col justify-center items-center p-[2rem]">
                        <div className='w-full flex justify-between mb-[5rem]'>
                            <h3 className="text-[#000000] text-[2rem] text-start  inter-font font-[500]">Potential
                                income Missed<br />
                                Month and Year</h3>
                            <div className='w-[7.1rem] h-[7.1rem]'>
                                <img src={InfluencerImg.info5} alt="Campaign Participated"
                                    className="w-full h-full mb-2" />
                            </div>
                        </div>
                        <div className="influencers-date-picker w-full flex justify-between items-center">
                            <p className="text-[#38414A] text-[4.8rem] inter-font font-[600]">
                                {formatNumber(
                                    getPotentialIncomeMissedByMonthAndYearForDashboardReducer?.data?.potentialIncome || 0
                                )}
                            </p>
                            <div className="influencers-date-picker w-[10rem] flex justify-between items-center">
                                <DatePicker
                                    selected={potentialMissedIncomeDate}
                                    onChange={(date) => setPotentialMissedIncomeDate(date)}
                                    dateFormat="MM/yyyy"
                                    showMonthYearPicker
                                    maxDate={moment((new Date())).format("YYYY-MM")}
                                    className='mt-2s border border-[#D5D5D5] w-[5rem] text-[#2B303466] text-[1.6rem] inter-font font-[500] p-2 rounded-[0.6rem] text-center'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <Popup
                isOpen={isPopupOpen}
                onClose={() => setPopupOpen(false)}
                title="Channel Registration"
                canDismiss
                icon={<SiLibreofficewriter color="#D72828" size={110} className="my-[5rem] size-[80px] lg:size-[100px]" />}
                content={<p className='text-[1.6rem] w-[80%] mx-auto text-center'>No YouTube channels found under this
                    account</p>}
                size="sm"
                primaryButton={{
                    text: 'Add Channel',
                    onClick: () => {
                        navigate("/influencer-channel")
                        setPopupOpen(false);
                    },
                }}
                secondaryButton={{
                    text: 'Not Now',
                    onClick: () => setPopupOpen(false),
                }}
            />
            <VerifyPopup
                isOpen={isSuccessPopupOpen}
                message={successMessage}
                modalAction={() => setIsSuccessPopupOpen(false)}
            />
            <Popup
                isOpen={isPhoneVerifyPopupOpen}
                title="Complete Profile"
                canDismiss={false}
                isOverflowVisible={true}
                content={
                    <div className="w-[85%] mx-auto !overflow-visible flex flex-col gap-4 mt-4">
                        {(!userInfo?.firstName || isAppleUser) && (
                            <div className="w-full">
                                <label className="text-[1.6rem] text-[#111729] roboto-thin font-[400]">First Name</label>
                                <input
                                    type="text"
                                    placeholder="First Name"
                                    value={firstName}
                                    disabled={otpShow}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    className={`w-full px-[1.6rem] py-[.8rem] bg-[#F3F9FA] border rounded-[1.2rem] focus:outline-none text-[1.6rem] ${errors.firstName ? 'border-red-500' : 'border-gray-300'}`}
                                />
                                {errors.firstName && <p className="text-red-500 text-[1.2rem]">{errors.firstName}</p>}
                            </div>
                        )}

                        {(!userInfo?.lastName || isAppleUser) && (
                            <div className="w-full">
                                <label className="text-[1.6rem] text-[#111729] roboto-thin font-[400]">Last Name</label>
                                <input
                                    type="text"
                                    placeholder="Last Name"
                                    value={lastName}
                                    disabled={otpShow}
                                    onChange={(e) => setLastName(e.target.value)}
                                    className={`w-full px-[1.6rem] py-[.8rem] bg-[#F3F9FA] border rounded-[1.2rem] focus:outline-none text-[1.6rem] ${errors.lastName ? 'border-red-500' : 'border-gray-300'}`}
                                />
                                {errors.lastName && <p className="text-red-500 text-[1.2rem]">{errors.lastName}</p>}
                            </div>
                        )}

                        {!userInfo?.gender && (
                            <div className="w-full">
                                <label className="text-[1.6rem] text-[#111729] roboto-thin font-[400]">Gender</label>
                                <select
                                    value={gender}
                                    disabled={otpShow}
                                    onChange={(e) => setGender(e.target.value)}
                                    className={`w-full px-[1.6rem] py-[.8rem] bg-[#F3F9FA] border rounded-[1.2rem] focus:outline-none text-[1.6rem] ${errors.gender ? 'border-red-500' : 'border-gray-300'}`}
                                >
                                    <option value="">Select Gender</option>
                                    <option value="MALE">Male</option>
                                    <option value="FEMALE">Female</option>
                                    <option value="OTHER">Other</option>
                                </select>
                                {errors.gender && <p className="text-red-500 text-[1.2rem]">{errors.gender}</p>}
                            </div>
                        )}

                        {!userInfo?.phoneNumber && (
                            <div className="w-full !overflow-visible">
                                <label className="text-[1.6rem] text-[#111729] roboto-thin font-[400]">Mobile Number</label>
                                <div className={`flex items-center w-full px-[1.6rem] py-[.8rem] bg-[#F3F9FA] border rounded-[1.2rem] focus:outline-none !overflow-visible ${errors.phoneNumber ? 'border-red-500' : 'border-gray-300'}`}>
                                    <DropdownWithSearch
                                        options={getAllCountryReducer?.data}
                                        onChange={setCountryCode}
                                        value={countryCode}
                                        disabled={otpShow}
                                    />
                                    <input
                                        type="number"
                                        placeholder="Phone Number"
                                        maxLength={10}
                                        value={phoneNumber}
                                        disabled={otpShow}
                                        onChange={(e) => {
                                            const input = e.target.value;
                                            if (input.length <= 10) {
                                                setPhoneNumber(input);
                                            }
                                        }}
                                        className="bg-[#F3F9FA] text-[1.6rem] border-none focus:ring-0 outline-none w-full ml-2"
                                    />
                                </div>
                                {errors.phoneNumber && <p className="text-red-500 text-[1.2rem] mt-1">{errors.phoneNumber}</p>}
                            </div>
                        )}

                        {!userInfo?.referredBy && (
                            <div className="w-full">
                                <label className="text-[1.6rem] text-[#111729] roboto-thin font-[400]">Referred By (Optional)</label>
                                <input
                                    type="text"
                                    placeholder="Enter referrer's name (if any)"
                                    value={referredBy}
                                    disabled={otpShow}
                                    onChange={(e) => setReferredBy(e.target.value)}
                                    className="w-full px-[1.6rem] py-[.8rem] bg-[#F3F9FA] border border-gray-300 rounded-[1.2rem] focus:outline-none text-[1.6rem]"
                                />
                            </div>
                        )}

                        {otpShow &&
                            <div className="mb-4">
                                <h2 className="text-[1.6rem] text-[#111729] roboto-thin font-[400] mb-2">Mobile OTP</h2>
                                <div className="flex justify-between items-center w-[75%]" onPaste={handlePaste2}>
                                    {otpMobile.map((value, index) => (
                                        <input
                                            key={index}
                                            id={`mobile-input-${index}`}
                                            type="text"
                                            maxLength="1"
                                            value={value}
                                            onChange={(e) => handleChange2(e, index)}
                                            onKeyDown={(e) => handleKeyDown2(e, index)}
                                            className={`w-[4.5rem] h-[4.5rem] border rounded-[.8rem] text-center text-[1.8rem] ${(message && !verifyMobileOtpReducer?.status) ? 'border-red-500' : 'border-gray-300'}`}
                                        />
                                    ))}
                                </div>
                                {message && <p className="text-red-500 text-[1.4rem] mt-2">{message}</p>}
                            </div>
                        }
                    </div>
                }
                primaryButtonWidth='w-[30rem]'
                size="mdsm"
                primaryButton={{
                    text: otpShow ? 'Verify' : (userInfo?.phoneNumber ? 'Submit' : 'Send OTP'),
                    onClick: () => {
                        if (otpShow) {
                            handleVerify();
                        } else if (userInfo?.phoneNumber) {
                            handleUpdateProfileOnly();
                        } else {
                            handleSendOtp();
                        }
                    },
                }}
            />
            <Popup
                isOpen={isPopupForTokenExpireOpen}
                onClose={() => setPopupForTokenExpireOpen(false)}
                title="Youtube Auth token"
                canDismiss
                icon={<SiLibreofficewriter color="#D72828" size={110} className="my-[5rem]" />}
                content={<p className='text-[1.6rem] w-[80%] mx-auto text-center'>Your Channel authentication is expired
                    or revoked</p>}
                size="sm"
                primaryButton={{
                    text: 'Re-auth',
                    onClick: () => {
                        window.open('/influencer/choose-access-type?platform=YOUTUBE', '_blank');
                        setPopupForTokenExpireOpen(false);
                    },
                }}
                secondaryButton={{
                    text: 'Not Now',
                    onClick: () => setPopupForTokenExpireOpen(false),
                }}
            />
            <Popup
                isOpen={isPopupForInstagramTokenExpireOpen}
                onClose={() => setPopupForInstagramTokenExpireOpen(false)}
                title="Instagram Auth token"
                canDismiss
                icon={<SiLibreofficewriter color="#D72828" size={110} className="my-[5rem]" />}
                content={<p className='text-[1.6rem] w-[80%] mx-auto text-center'>Your Instagram authentication is expired
                    or revoked</p>}
                size="sm"
                primaryButton={{
                    text: 'Re-auth',
                    onClick: () => {
                        window.open('/influencer/choose-access-type?platform=INSTAGRAM', '_blank');
                        setPopupForInstagramTokenExpireOpen(false);
                    },
                }}
                secondaryButton={{
                    text: 'Not Now',
                    onClick: () => setPopupForInstagramTokenExpireOpen(false),
                }}
            />
        </div>
    );
};

export default InfluencerDashboard;
